import { useState } from "react";
import { Play } from "lucide-react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";

export const CoachIntroVideo = ({ coachId, coachName, videoId }) => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        data-testid={`coach-video-btn-${coachId}`}
        aria-label={`Watch ${coachName}'s introduction video`}
        className="group/video mt-5 flex w-full items-center gap-4 border border-cream-border bg-cream p-2 pr-4 text-left transition-colors duration-300 hover:border-gold"
      >
        <span className="relative block aspect-video w-28 shrink-0 overflow-hidden bg-forest">
          <img
            src={`https://i.ytimg.com/vi/${videoId}/hqdefault.jpg`}
            alt=""
            loading="lazy"
            className="h-full w-full object-cover opacity-90 transition-transform duration-500 group-hover/video:scale-105"
          />
          <span className="absolute inset-0 flex items-center justify-center bg-forest/30">
            <span className="flex h-8 w-8 items-center justify-center rounded-full bg-cream-light/95 shadow transition-transform duration-300 group-hover/video:scale-110">
              <Play className="ml-0.5 h-3.5 w-3.5 fill-forest text-forest" strokeWidth={1.5} />
            </span>
          </span>
        </span>
        <span>
          <span className="block font-sans text-[10px] tracking-[0.25em] uppercase text-gold">Intro Video</span>
          <span className="mt-1 block font-serif text-lg leading-tight text-forest">Meet {coachName.split(" ")[0]}</span>
        </span>
      </button>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent
          data-testid={`coach-video-modal-${coachId}`}
          tabIndex={-1}
          onOpenAutoFocus={(e) => {
            e.preventDefault();
            e.currentTarget.focus();
          }}
          className="w-[calc(100vw-2rem)] max-w-4xl gap-0 rounded-none border-cream-border bg-forest p-0 sm:rounded-none [&>button]:text-cream-light [&>button]:opacity-90"
        >
          <div className="flex h-12 items-center px-5 pr-12">
            <DialogTitle className="font-serif text-lg font-normal text-cream-light">
              Meet {coachName}
            </DialogTitle>
          </div>
          <DialogDescription className="sr-only">YouTube introduction video</DialogDescription>
          {open && (
            <div className="aspect-video w-full">
              <iframe
                data-testid={`coach-video-iframe-${coachId}`}
                src={`https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1&rel=0&modestbranding=1`}
                title={`${coachName} introduction video`}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                className="h-full w-full"
              />
            </div>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
};
